import { message,Button, Col, ConfigProvider, Layout, Pagination, Popconfirm, Row, Statistic, Table, Popover } from 'antd';
import { Content } from 'antd/lib/layout/layout';

import React, { useEffect, useRef, useState } from "react";
import OAMSider from '../oam-sider';
import Cookies from 'js-cookie';
import { sendHttpPostRequest } from '../../../api/http-request';
import Search from 'antd/lib/input/Search';
import zhCN from 'antd/lib/locale/zh_CN';
import GlobalCss from '@/global.module.less'
import UserCard from '../user/oam-userinfo-card';


const channelMap = new Map([['爱数科', 1], ['爱数课', 2]]);

export interface Props {}

export const OAMClassRoomList: React.FC<Props> = (props) => {
    const [classroomResult, setClassroomResult] = useState([] as any[]);  // 当前显示的结果页
    const [resultSum, setResultSum] = useState(0);  // 搜索返回的结果数
    const [totalCount, setTotalCount] = useState(0);  // 搜索返回的结果数

    const queryContent = useRef('');  // 记录搜索串
    const page = useRef(1);  // 记录当前的页数
    const pageSize = useRef(10);  // 记录当前每页展示数量

    const channelFilters = useRef([]);  // 渠道过滤项

    useEffect(() => {
        queryClassRoomList();
    }, [])

    /**
     * 查询教室列表
     */
    const queryClassRoomList = () => {
        sendHttpPostRequest(
            'classroom/api/oam_query_classroom_list',
            {
                sessionid: Cookies.get("sessionid"), 
                page: page.current,
                pagesize: pageSize.current,
                query: queryContent.current
            },
            queryChapterListCallback
        )
    }

    /**
     * 查询章节列表回调
     * @param response
     */
    const queryChapterListCallback = (response: any) => {
        // console.log(response)
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=oam_classroom';
        } else if (response.is_ok == true) {
            // 成功
            setClassroomResult(response.query_list);
            //console.log(response)
            setResultSum(response.total_sum);
            setTotalCount(response.total_count);
            //setSysCount(response.sys_count);
            //setUserCount(response.user_count);
            //setOnlineCount(response.online_count);
        }// else if (response.code == -501) {
            // 权限不足
            //window.location.href = '/oam_login?next=oam_chapter';
        //} else {
            //message.error(response.message);
        //}
    }


    //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
        queryClassRoomList();
       
    }

   
    /**
     * 删除教室
     */
     const deleteClassRoom = (classroomId: string | number) => {
        sendHttpPostRequest(
            'classroom/api/oam_delete_classroom',
            {
                sessionid: Cookies.get("sessionid"),
                classroom_id: classroomId,
            },
            (response: any) => {
                // console.log(response)
                message.destroy();
                if (response.code == -100) {
                    // 未登录
                    window.location.href = '/oam_login?next=oam_classroom';
                } else if (response.is_ok == true) {
                    // 成功
                    message.success("删除成功");
                    const newResultClassRoom = [...classroomResult]
                    setClassroomResult(newResultClassRoom.filter(item=> item.id !== classroomId))
                    
                } /*else if (response.code == -501) {
                    // 权限不足
                    window.location.href = '/oam_login?next=oam_chapter';
                } */else {
                    message.error(response.message);
                }
            }
        )
    }

 
     //点击了查看按钮
  const onLookOverBtnClick = (event:any) => {
    event.preventDefault()
    window.open('/oam_classroom_detail?id=' + event.currentTarget.value)
  }

  //点击了编辑按钮
  const onEditBtnClick = (event:any) => {
    //message.success('编辑数据' + event.currentTarget.value)
    event.preventDefault()
    window.open('/oam_classroom_edit?id=' + event.currentTarget.value)
  }

    //点击新建按钮
    const onCreateBtnClick = (event:any) => {
        //message.success('编辑数据' + event.currentTarget.value)
        event.preventDefault()
        window.open('/oam_chapter_create')
      }


  // 点击 删除
  const onDeleteBtnClick = (name:string, id:number) => {
    deleteClassRoom(id)
  }


 



    // 渲染操作
    const renderActions = (text:any, record:any) => {
        return <>
        <Row justify="center" align="middle" gutter={[8, 5]} wrap={false} >
       <Col style={{width:50}}><Button style={{borderRadius:20,fontSize:12}} size='small' id="lookover" value={record.id} type="default" onClick={onLookOverBtnClick} > 查 看 </Button></Col>
         {/*<Col style={{width:50}}><Button style={{borderRadius:20,fontSize:12}} size='small' id="edit" value={record.id} type="dashed" onClick={onEditBtnClick}> 编 辑 </Button> </Col> */}
           
            { <Col style={{width:50}}>
            <Popconfirm placement="top" title={'确认删除教室"' + record.name + '"吗？'} onConfirm={onDeleteBtnClick.bind(this, record.name,record.id)} okText="确认" cancelText="取消">
            <Button style={{borderRadius:20,fontSize:12}} size='small' id="delete" danger value={record.id} > 删 除 </Button> 
            </Popconfirm></Col> }
        </Row>

        </>

        }

 
  
    //点击了搜索按钮
    const onSearchBtn = (value: string) => {
        page.current = 1;
        queryContent.current = value;
        queryClassRoomList();
    }

    // 表格发生变化
    const onTableChange:any = (pagination:any, filters:any, sorter:any, extra: { currentDataSource: [], action: any })=> {
        if (sorter.order) { //如果选择了排序列
            //order.current = sorter.order;
            //order_by.current = sorter.field;
        }
        if (filters.sex) { //如果选择了过滤列
            //sexFilters.current = filters.sex;
        } else {
            //sexFilters.current = [];
        }
        if (filters.channel_name) {
            channelFilters.current = filters.channel_name.map(element=> {
                return channelMap.get(element);
            });
        } else {
            channelFilters.current = [];
        }
        page.current = 1;
        //queryUserInfo();
    }

    // 表格列
    const cols: any = [
        {
            title: "序号",
            dataIndex: "id",
            key: "id",
            width: 60,
            align: 'left',
        },
        {
            title: "名称",
            dataIndex: "name",
            key: "name",
            width: 100,
            align: 'left',
            ellipsis: true,
        },
        {
            title: "教师",
            dataIndex: "real_name",
            key: "real_name",
            width: 100,
            align: 'left',
            ellipsis: true,
            render: (text, record) => {
                return (
       
                      <Popover
                        arrowPointAtCenter={true}
                        trigger="hover"
                        placement="left"
                        content={<UserCard user_id={record?.user_id} />}
                        title={null}
                      >
                        {text == ""? record.user_name : text}
                      </Popover>
           
                )
              },
        },
        {
            title: "项目",
            dataIndex: "course_name",
            key: "course_name",
            width: 200,
            align: 'left',
            ellipsis: true,
        },
        {
            title: "院校",
            dataIndex: "college_name",
            key: "college_name",
            width: 100,
            align: 'left',
            ellipsis: true,
        },
        {
            title: "学生数",
            dataIndex: "user_count",
            key: "user_count",
            width: 80,
            align: 'center',
        },
        {
            title: "创建时间",
            dataIndex: "create_time",
            key: "create_time",
            width: 200,
            align: 'left',
        },
        {
            title: "操作",
            dataIndex: "actions",
            key: "actions",
            width: 100,
            ellipsis: false,
            align: 'center',
            fixed: 'right',
            render: renderActions,
        },
    ]

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <OAMSider keys={"8"} openKeys={["sub-project"]}  ></OAMSider>
            <Layout style={{backgroundColor:'#f9f9f9'}}>
                <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:400,margin:30 ,paddingTop:20}}>
                
                    <div style={{paddingLeft:30,paddingRight:30}}>
                    <Row align="middle"  gutter={16}>
                        <Col flex='80px'>
                            <Statistic title="班级总数" value={totalCount} />
                        </Col>
                        
                        <Col flex='250px'>
                            <Search
                                placeholder="搜索班级"
                                style={{ width: 350 }}
                                enterButton={true}
                                onSearch={onSearchBtn}
                            />

                        </Col>
                       
                        {/*<Col flex='auto' style={{textAlign:'right'}}> <Button style={{borderRadius:20}} type={'primary'} onClick={onCreateBtnClick}>+新建</Button></Col> */}
                        </Row>
                      

                        <div style={{height:500}} className={GlobalCss.tableWrapper}>
                        <ConfigProvider locale={zhCN}>
                            <Table
                                dataSource={classroomResult}
                                columns={cols}
                                rowKey={record => record.id}
                                pagination={false}
                                scroll={{ x: 800 }}
                               // bordered={true}
                                onChange={onTableChange}
                            />
                        </ConfigProvider>
                        </div>

                        <ConfigProvider locale={zhCN}>
                            <div style={{marginBottom:30,paddingTop:30,textAlign:"center"}} className={"css.pagination"} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={resultSum}
                                    current={page.current}
                                    defaultPageSize={10}
                                    hideOnSinglePage={true}
                                    onChange={onPageChange}
                                    showQuickJumper={true}
                                    showTotal={total => `共 ${total} 班级`}
                                    pageSizeOptions={["10","20","50","100"]}
                                />
                            </div>
                        </ConfigProvider>
                    </div>
                </Content>
            </Layout>
        </Layout>

    )

}

export default OAMClassRoomList


